import React, { useState, useEffect } from "react";
import { Box, Grid, Typography, Paper, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomAppBar from "../../components/AppBar";
import api from "../../globals/axios";
import { makeStyles } from "@mui/styles";
import { useAlert } from "../../components/Alert";
import { useParams } from "react-router-dom";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    minHeight: "100vh",
    marginBottom: "-4rem",
  },
  container: {
    padding: "20px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  title: {
    textAlign: "center",
    padding: "20px 0",
    borderRadius: "4px",
    marginBottom: "20px",
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    minHeight: "200px",
  },
  signupCard: {
    padding: "15px",
    marginBottom: "10px",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    borderRadius: "4px",
  },
}));

export default function CampaignDetails() {
  const { t } = useTranslation();
  const classes = useStyles();
  const { showAlert } = useAlert();
  const { campaignId } = useParams();

  const [signups, setSignups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [campaignTitle, setCampaignTitle] = useState("");

  useEffect(() => {
    fetchCampaignSignups();
  }, [campaignId]);

  const fetchCampaignSignups = async () => {
    try {
      setLoading(true);
      const response = await api.get(
        `/leadgeneration/get-registered-users-for-campaign?campaign_id=${campaignId}`
      );
      setSignups(response.data);

      if (response.data.length > 0) {
        setCampaignTitle(response.data[0].campaign_title);
      }
    } catch (err) {
      console.log("Error loading campaigns", err);
      showAlert(
        "error",
        "Failed to load campaign signups. Please try again later!"
      );
    } finally {
      setLoading(false);
    }
  };

  const renderSignupsList = () => {
    if (loading) {
      return (
        <Box className={classes.loaderContainer}>
          <CircularProgress size={60} thickness={4} />
        </Box>
      );
    }

    if (signups.length === 0) {
      return (
        <Typography variant="body1" textAlign="center">
          {t("No signups found for this campaign")}
        </Typography>
      );
    }

    return signups.map((signup, index) => (
      <Box key={index} className={classes.signupCard}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1">
              {t("Name")}: {signup.user_full_name}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1">
              {t("Phone Number")}: {signup.user_phone_number}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1">
              {t("Role")}: {signup.role}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1">
              {t("Quantity")}: {signup.quantity}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="caption">
              {t("Signed Up At")}:{" "}
              {new Date(signup.signed_up_at).toLocaleString()}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    ));
  };

  return (
    <Box className={classes.root} component={Paper}>
      <CustomAppBar />

      <Box className={classes.container}>
        <Paper className={classes.title} elevation={0}>
          <Typography variant="h5">{campaignTitle}</Typography>
        </Paper>

        <Box mt={4}>{renderSignupsList()}</Box>
      </Box>
    </Box>
  );
}
